import { useNavigate, useParams } from 'react-router-dom';

import { UploadContentLayout } from '@/layout';
import { CreateVideoComponent } from '@/pages/Event/components/CreateVideo';

export const UploadContentCreateTributeVideo = () => {
  const { eventId } = useParams();
  const navigate = useNavigate();

  return (
    <UploadContentLayout
      goBack={() => navigate(`/events/${eventId}/upload-content/tribute-videos`)}>
      <CreateVideoComponent />
    </UploadContentLayout>
  );
};
